import { PAYER_TYPE_STUDENT } from 'constants/fields';

export const isStudentRelationshipValue = (value: unknown): boolean => {
  if (typeof value !== 'string') {
    return false;
  }
  const normalized = value.trim().toLowerCase();
  return normalized === PAYER_TYPE_STUDENT || normalized.includes('self');
};
